import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpcenterdataService } from 'src/app/services/spcenterdata.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification-service';
import Swal from 'sweetalert2';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';

@Component({
  selector: 'app-add-device-popup',
  templateUrl: './add-device-popup.component.html',
  styleUrls: ['./add-device-popup.component.scss']
})
export class AddDevicePopupComponent implements OnInit {
  data: any;
  deviceform: FormGroup;
  form: FormGroup
  rolelist: any = [{ key: 1, value: 'Mikrotik Home CPE' }];
  file: File;
  fileName: string;
  isFileSelected = false
  FileExtention: string;
  batchProcessModuleType = BatchProcessModuleType
  sessionDataString: any
  serviceProviderList: any;
  constructor(
    private SpcenterdataService: SpcenterdataService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddDevicePopupComponent>,
    private toastr: NotificationService,
    private sessionService: UserSessionService,
    private lookupDataService: LookupDataServiceService,
    @Inject(MAT_DIALOG_DATA) public value: any,


  ) { }

  ngOnInit(): void {
    this.deviceform = this.formBuilder.group({
      model: [null, Validators.required],
      serial: [null, Validators.required],
      mac: [null, Validators.required],
      role: [this.rolelist[0].key, Validators.required]
    })
    this.form = this.formBuilder.group({
      AttachmentFileName: [null, Validators.required],
      agent: [null],
      serviceProviderId: [null],
    })
    if (!this.value?.hideAgent) {
      this.form.controls['agent'].setValidators([Validators.required])
      this.sessionDataString = JSON.parse(localStorage.getItem(this.sessionService.localStorageSessionKey));
      this.form.controls['agent'].setValue(this.sessionDataString.emailid);
    }
    console.log(this.value);

    if (this.value.head === 'LTE SIM Import') {
      this.lookupDataService.getLteServiceProviderList().subscribe((res: any) => {
        this.serviceProviderList = res;
      });
    }

    if (this.value.title == 'legalexcelimport') {
      this.sessionDataString = JSON.parse(
        localStorage.getItem(this.sessionService.localStorageSessionKey)
      );
      console.log('session', this.sessionDataString);
      this.form.controls['agent'].setValue(this.sessionDataString.emailid)

    }
  }
  adddevice() {
    this.data = this.deviceform.value;
    console.log(this.data)
    if (this.deviceform.valid)
      this.SpcenterdataService.saveInventoryDevice(this.data).subscribe((result) => {
        if (result)
          this.toastr.showSuccess("New Device Added Succesfully");

        this.dialogRef.close(true);
      })
  }
  downloadtemplate() {
    const link = document.createElement('a');
    if (this.form.value.serviceProviderId == 45) {
      link.href = 'assets/template/SIMTemplateComsol.xlsx';
      link.download = 'SIMTemplateComsol.xlsx';
    }
    else if (this.value.head === 'LTE Router Import') {
      link.href = 'assets/template/RouterTemplate.xlsx';
      link.download = 'RouterTemplate.xlsx';
    }
    else if (this.value.head === 'LTE SIM Import') {
      link.href = 'assets/template/SIMTemplate.xlsx';
      link.download = 'SIMTemplate.xlsx';
    }
    else if (this.value.head === 'LTE SIM Import') {
      link.href = 'assets/template/SIMTemplate.xlsx';
      link.download = 'SIMTemplate.xlsx';
    }
    else if (this.value.title == 'excelimport') {
      link.href = 'assets/template/BulkUploadTemplate.xlsx';
      link.download = 'BulkUploadTemplate.xlsx';
    }
    else if (this.value.title == 'legalexcelimport') {
      link.href = 'assets/template/LegalCollectionTemplate.xlsx';
      link.download = 'LegalCollectionTemplate.xlsx';
    }
    else if (this.value.title == 'legalexcelrevoke') {
      link.href = 'assets/template/RevertLegalCollectionTemplate.xlsx';
      link.download = 'RevertLegalCollectionTemplate.xlsx';
    }

    link.click();
  }
  upload() {
    if (this.form.valid) {
      let formdata: FormData = new FormData();
      if (this.value.title === 'legalexcelimport') {
        formdata.append('Agent', this.form.value.agent);
        formdata.append('BatchProcessModuleType', this.batchProcessModuleType.BulkLegalCollection.toString());
      }
      // else if(this.value.title === 'legalexcelimport' && !this.form.value.agent)
      //   this.form.controls['agent'].setErrors({required: true})
      if (this.value.title === 'excelimport') {
        formdata.append('BatchProcessModuleType', this.batchProcessModuleType.BulkLegalCollection.toString());
      }
      formdata.append('file', this.file);
      let productType: number | null = null;
      if (this.value.head === 'LTE SIM Import') {
        productType = 1;
        if (this.form.value.serviceProviderId != null)
          formdata.append('ServiceProviderId', this.form.value.serviceProviderId);
        else {
          this.form.controls['serviceProviderId'].markAsTouched();
          this.form.controls['serviceProviderId'].updateValueAndValidity();
          return this.toastr.showError("Please select Service Provider");
        }

      } else if (this.value.head === 'LTE Router Import') {
        productType = 2;
      }

      if (productType !== null) {
        formdata.append('productType', productType.toString());
      }



      console.log(formdata);
      this.dialogRef.close(formdata)
    }
  }
  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }

      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.FileExtention = fileExtension;
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      console.log(this.file);
      document.body.removeChild(inputElement);
    });
  }

  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }

  Close() {
    this.dialogRef.close(false);
  }
}
